import React, { useState, useEffect } from 'react';

const ActivityFeedFooter = ({ selectedRegion, compact = false }) => {
  const [feedData, setFeedData] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  // Fetch live feed
  const fetchFeed = async () => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/area-activity/live-feed?region_id=${selectedRegion.id}`
      );
      const data = await response.json();
      setFeedData(data);
    } catch (error) {
      console.error('Error fetching live feed:', error);
    }
  };

  // Initial fetch and polling every 30 seconds
  useEffect(() => {
    fetchFeed();
    const interval = setInterval(fetchFeed, 30000);
    return () => clearInterval(interval);
  }, [selectedRegion.id]);

  return (
    <div style={{
      overflow: 'hidden',
      position: 'relative'
    }}>
      <div style={{
        fontSize: '11px',
        color: '#94a3b8',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        justifyContent: 'center'
      }}>
        <span style={{ color: '#FF00FF', fontWeight: '600', fontSize: '12px' }}>LIVE ACTIVITY:</span>
        <span style={{ 
          animation: feedData ? 'fadeIn 0.5s ease-in' : 'none',
          color: '#e2e8f0',
          fontSize: '11px'
        }}>
          {feedData?.summary || 'Loading activity feed...'}
        </span>
        {feedData && (
          <span style={{
            fontSize: '10px',
            color: '#64748b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <span style={{
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              background: '#22c55e',
              animation: 'pulse 2s infinite'
            }}></span>
            Live
          </span>
        )}
      </div>
    </div>
  );
};

export default ActivityFeedFooter;
